import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const FloatingWriteButton: React.FC = () => {
  return (
    <FloatingButton to="/blog/write">
      <ButtonIcon>✍️</ButtonIcon>
      <ButtonText>AI 글작성</ButtonText>
    </FloatingButton>
  );
};

const FloatingButton = styled(Link)`
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  width: 4rem;
  height: 4rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-decoration: none;
  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.3);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1000;
  overflow: hidden;
  
  &:hover {
    transform: translateY(-4px) scale(1.05);
    box-shadow: 0 12px 32px rgba(102, 126, 234, 0.4);
    width: auto;
    padding: 0 1.5rem;
    border-radius: 2rem;
  }

  @media (max-width: 768px) {
    bottom: 1.5rem;
    right: 1.5rem;
    width: 3.5rem;
    height: 3.5rem;
    
    &:hover {
      width: auto;
      padding: 0 1.25rem;
    }
  }
`;

const ButtonIcon = styled.span`
  font-size: 1.5rem;
  transition: all 0.3s ease;
  
  ${FloatingButton}:hover & {
    margin-right: 0.5rem;
  }

  @media (max-width: 768px) {
    font-size: 1.25rem;
    
    ${FloatingButton}:hover & {
      margin-right: 0.4rem;
    }
  }
`;

const ButtonText = styled.span`
  font-size: 0.875rem;
  font-weight: 600;
  white-space: nowrap;
  opacity: 0;
  width: 0;
  overflow: hidden;
  transition: all 0.3s ease;
  
  ${FloatingButton}:hover & {
    opacity: 1;
    width: auto;
  }

  @media (max-width: 768px) {
    font-size: 0.8rem;
  }
`;

export default FloatingWriteButton; 